var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"o-the-header"},[_c('div',{staticClass:"o-the-header-navigation"},[_c('MoleculeTheHeaderLogo'),_c('MoleculeTheHeaderSubMenu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }